import { Injectable } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';

/** Serviço de router para navegação da análise de mercado de clientes */
@Injectable({
    providedIn: 'root'
})
export class ClienteAnaliseMercadoRouterService {
    constructor(private router: Router) { }

    /** Abre a análise de mercado do cliente */
    openAnalise(idCliente: number, ano: number, activatedRoute: ActivatedRoute) {
        this.router.navigate(['./', idCliente, 'ano', ano], {relativeTo: activatedRoute});
    }

    /** Abre o lançamento da análise de mercado da classificação */
    openLancamentoClassificacao(idCliente: number, ano: number, idClienteAnaliseMercadoClassificacao: number, returnToRoot: boolean, activatedRoute: ActivatedRoute) {
        // Query Params
        const queryParams = new Map();
        // Return To Root
        if (returnToRoot) {
            queryParams['returnToRoot'] = returnToRoot;
        }

        this.router.navigate(['./', idCliente, 'ano', ano, 'classificacao', idClienteAnaliseMercadoClassificacao], {relativeTo: activatedRoute, queryParams});
    }

    goToRoot(activatedRoute: ActivatedRoute) {
        this.router.navigate(['/clientes/rap-3d'], {relativeTo: activatedRoute});
    }
}
